sn-footer-type-1 {
  // Remove the container's top padding for this footer only. Scoped under the
  // product host so the base footer-type-5 (used elsewhere) is untouched.
  // `sn-footer-type-1 .me-container` (0,1,1) beats the `.me-container--y-gap-*`
  // modifier (0,1,0) that applies the 80px vertical padding.
  .me-container {
    padding-top: 0;
  }

  .footer-type-1 {
    .me-container {
      padding-bottom: 0;
    }
  }

  .footer-menu-type-1__items {
    .me-button {
      text-align: left;
    }
  }

  [slot='menus'] {
    display: flex;
    flex-direction: column;

    footer-menu-type-1:nth-child(2) {
      margin-top: map-get($spacings, md);
    }
  }

  // Scoped under the footer host so it does NOT leak to other components
  // that use form-free-trial-type-1 in Light DOM (e.g. hero headers).
  .form-free-trial-type-1 {
    display: flex;

    @include above($breakpoint-desktop-md) {
      justify-content: flex-end;
    }
  }
}

.footer-apps-list {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
}

.footer-apps-list__item {
  margin-bottom: 0;

  &:first-child {
    margin-right: 12px;
  }
}

.footer-apps-list__item svg {
  display: block;

  &:hover {
    opacity: 0.85;
    transition: opacity 0.2s;
  }
}

// The store badges and rating stars arrive as `me-icon` pointing at an SVG URL, and page data
// carries no width/height for them — so the icon box is 0x0 until the file lands and the footer
// reflows around it. Reserving their intrinsic sizes (measured on production: badges 124x40,
// stars 11x11) keeps the box stable; `me-icon` scales its content to the box, so nothing moves
// once the SVG arrives.
.footer-apps-list__link .me-icon {
  width: 124px;
  height: 40px;
}

.footer-apps-list__star .me-icon {
  width: 11px;
  height: 11px;
}

.footer-apps-list__link {
  display: flex;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    border-radius: 4px;
    border-width: 2px;
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);

    &::after {
      opacity: 0;
    }
  }
}

.footer-apps-list__info {
  display: flex;
  align-items: center;

  // @include above($media-screen-desktop) {
  justify-content: flex-start;
  margin-top: 8.5px;

  // }
}

.footer-apps-list__star {
  margin-right: 4px;

  svg {
    vertical-align: unset;
  }
}

.footer-apps-list__star-value {
  position: relative;
  margin-right: 8px;
  font-weight: 700;
  font-size: 11px;
  line-height: 16px;
  color: #2c2c2c;

  &::after {
    position: absolute;
    content: '';
    top: 4px;
    right: -4px;
    background-color: #b9c2c8;
    border-radius: 50%;
    width: 1px;
    height: 8px;
  }
}

.footer-apps-list__ratings {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #2c2c2c;
}

.footer-column__social--mobile {
  .footer-apps-list {
    display: flex;
    justify-content: center;
  }

  .footer-apps-list__item {
    // @include above($media-screen-tablet) {
    margin-bottom: 28px;

    // }
  }
}
